import { Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackBarComponent } from '../custom-snack-bar/custom-snack-bar.component';

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss']
})
export class CopyButtonComponent implements OnInit {

  @Input() value: string = "";

  constructor(
    private _clipboard: Clipboard,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  copyToClipboard() {
    const stringValue = String(this.value)
    if (stringValue) {
      this._clipboard.copy(stringValue);
      this._snackBar.openFromComponent(CustomSnackBarComponent, {
        data: {
          message: "Value copied to the clipboard.",
          type: 'success'
        },
        duration: 2000
      })
    } else {
      this._snackBar.openFromComponent(CustomSnackBarComponent, {
        data: {
          message: "No value could be copied.",
          type: 'failure'
        },
        duration: 2000
      })
    }
  }
}
